import { useEffect } from 'react';
import { airflowSyncStore } from '../stores/airflowSyncStore';
import { useQuery } from '@tanstack/react-query';
import { airflowSyncDatetimeOptions } from '../api';
/**
 * Custom hook to synchronize the MobX countdown store with the
 * latest sync time fetched by React Query.
 * This hook should be called once in a high-level component.
 */
const useSyncAirflowTimer = () => {
  const { data } = useQuery(airflowSyncDatetimeOptions);

  useEffect(() => {
    if (data) {
      airflowSyncStore.setTargetTime({ latestSyncIso: data.last_sync_dt });
    }

    return () => {
      // Optional: If the timer should stop when the app is "closed"
      // countdownStore.clearTimer();
    };
  }, [data]);
};

export default useSyncAirflowTimer;
